export function startSceneLayout(k) {

    // --- Level Generation ---
    const decorations = k.addLevel(
        [
            "2.................",
            "2.2211............",
            ".1111.............",
            "1.................",
            "1.1.............00",
            "...............000",
            ".1.......1.1.1.1..",
        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(-64, -64),
            tiles: {
                "1": () => [k.sprite("foam", {anim: "idle"}), k.scale(1), k.z(0)],
                "2": () => [k.sprite("tileShadow"), k.z(2), k.opacity(1), k.scale(1)],
                "3": () => [k.sprite("waterRock1", {anim: "idle"}), k.z(2), k.opacity(1), k.scale(1)],
                "4": () => [k.sprite("waterRock2", {anim: "idle"}), k.z(2), k.opacity(1), k.scale(1)],
                "5": () => [k.sprite("waterRock3", {anim: "idle"}), k.z(2), k.opacity(1), k.scale(1), k.pos(-25, -20)],
                "6": () => [k.sprite("waterRock4", {anim: "idle"}), k.z(2), k.opacity(1), k.scale(1), k.pos(0, 20)],
                "7": () => [k.sprite("waterRock1", {anim: "idle"}), k.z(2), k.opacity(1), k.scale(1), k.pos(40, -10)],
            }
        }
    );

    const floor0 = k.addLevel(
        [
            "..................",
            "..ssz&............",
            "..wxc.............",
            "..................",
            "..r...............",
            "..................",
            ".r................",
            "..................",
        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(0, 0),
            tiles: {
                ".": () => [k.sprite("Tilemap_color5", {frame: 4}), k.z(1)],
                "z": () => [k.sprite("Tilemap_color5", {frame: 1}), k.z(1)],
                "s": () => [k.sprite("Tilemap_color5", {frame: 10}), k.z(1)],
                "w": () => [k.sprite("Tilemap_color5", {frame: 18}), k.z(1)],
                "x": () => [k.sprite("Tilemap_color5", {frame: 19}), k.z(1)],
                "c": () => [k.sprite("Tilemap_color5", {frame: 20}), k.z(1)],
                "&": () => [k.sprite("Tilemap_color5", {frame: 29}), k.z(1)],
                "r": () => [k.sprite("Tilemap_color5", {frame: 30}), k.z(1)],
            }
        }
    );

    const floor1 = k.addLevel(
        [
            "552a..............",
            "53lq..............",
            "6!................",
            "3.................",
            "!.................",
            ".........y.y.y.y..",
            ".........*.*.*.*..",
        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(0, 0),
            tiles: {
                ".": () => [k.sprite("Tilemap_color1", {frame: 4}), k.z(2)],
                "1": () => [k.sprite("Tilemap_color1", {frame: 23}), k.z(2)],
                "2": () => [k.sprite("Tilemap_color1", {frame: 24}), k.z(2)],
                "3": () => [k.sprite("Tilemap_color1", {frame: 25}), k.z(2)],
                "4": () => [k.sprite("Tilemap_color1", {frame: 14}), k.z(2)],
                "5": () => [k.sprite("Tilemap_color1", {frame: 15}), k.z(2)],
                "6": () => [k.sprite("Tilemap_color1", {frame: 16}), k.z(2)],
                "7": () => [k.sprite("Tilemap_color1", {frame: 5}), k.z(2)],
                "8": () => [k.sprite("Tilemap_color1", {frame: 6}), k.z(2)],
                "9": () => [k.sprite("Tilemap_color1", {frame: 7}), k.z(2)],
                "e": () => [k.sprite("Tilemap_color1", {frame: 19}), k.z(2)],
                "r": () => [k.sprite("Tilemap_color1", {frame: 33}), k.z(2)],
                "t": () => [k.sprite("Tilemap_color1", {frame: 34}), k.z(2)],
                "y": () => [k.sprite("Tilemap_color1", {frame: 35}), k.z(2)],
                "k": () => [k.sprite("Tilemap_color1", {frame: 41}), k.z(2)],
                "l": () => [k.sprite("Tilemap_color1", {frame: 42}), k.z(2)],
                "m": () => [k.sprite("Tilemap_color1", {frame: 43}), k.z(2)],
                ";": () => [k.sprite("Tilemap_color1", {frame: 50}), k.z(2)],
                ":": () => [k.sprite("Tilemap_color1", {frame: 51}), k.z(2)],
                "!": () => [k.sprite("Tilemap_color1", {frame: 52}), k.z(2)],
                "*": () => [k.sprite("Tilemap_color1", {frame: 53}), k.z(2)],
                "a": () => [k.sprite("Tilemap_color1", {frame: 39}), k.z(2)],
                "q": () => [k.sprite("Tilemap_color1", {frame: 48}), k.z(2)],
            }
        }
    );

    const floor2 = k.addLevel(
        [
            "3...........c......",
            "m..................",
            "...................",

        ],
        {
            tileWidth: 64, tileHeight: 64, pos: k.vec2(0, 0),
            tiles: {
                ".": () => [k.sprite("Tilemap_color2", {frame: 4}), k.z(3)],
                "3": () => [k.sprite("Tilemap_color2", {frame: 25}), k.z(3)],
                "m": () => [k.sprite("Tilemap_color2", {frame: 43}), k.z(3)],
                "ù": () => [k.sprite("sheep", {anim: "idle", flipX: true}), k.z(3), k.pos(-15, 0)],
                "*": () => [k.sprite("sheep", {anim: "idle"}), k.z(3), k.pos(-35, 0)],
                "^": () => [k.sprite("sheep", {anim: "idle"}), k.z(3), k.pos(10, 0)],
                "$": () => [k.sprite("sheep", {anim: "idle"}), k.z(4), k.pos(10, 38)],
                "1": () => [k.sprite("sheep", {anim: "idle"}), k.z(5), k.pos(10, 74)],
                ")": () => [k.sprite("sheep", {anim: "idle", flipX: true}), k.z(4), k.pos(-15, 38)],
                "=": () => [k.sprite("sheep", {anim: "idle"}), k.z(4), k.pos(-35, 38)],
            }
        }
    );

    const gameTitle = k.add([
        k.sprite("killMoutMout"),
        k.pos(750, 145),
        k.anchor("center"),
        k.z(20),
        k.scale(1),
        k.animate(),
    ]);

    gameTitle.animate("scale", [k.vec2(0.27), k.vec2(0.29), k.vec2(0.27)], {
        duration: 2.5,
        easing: k.easings.easeInOutQuad,
    });


    const shadow = k.add([
        k.ellipse(10, 10),
        k.pos(750, 260),
        k.anchor("center"),
        k.z(1),
        k.scale(1),
        k.opacity(0.4),
        k.color(0, 0, 0),
        k.animate(),  // ← ajouter
    ]);

    shadow.animate("radiusX", [180, 200, 180], {
        duration: 2.5,
        easing: k.easings.easeInOutQuad,  // même easing que le bouton
    });

    const cloud1 = k.add([
        k.sprite("clouds1"),
        k.pos(400, 0),
        k.z(5),
        k.anchor("topleft"),
        k.scale(0.8),
        k.animate()
    ])
    const cloud2 = k.add([
        k.sprite("clouds3"),
        k.pos(-100, 200),
        k.z(30),
        k.anchor("topleft"),
        k.scale(0.8),
        k.animate()
    ])

    cloud1.animate("pos", [k.vec2(-400, 10), k.vec2(1120, 10)], {
        duration: 25,
        // loop: true,
    });

    cloud2.animate("pos", [k.vec2(-100, 85), k.vec2(1120, 85)], {
        duration: 20,
    });

    function generateSheepPile(pos, zIndex, flipX){
        k.add([
            k.sprite('sheep', {anim:"idle", flipX: flipX}),
            k.pos(pos),
            k.z(zIndex),
        ])
    }

    generateSheepPile(k.vec2(64*9+30,64*5),4, false);
    generateSheepPile(k.vec2(64*9-15,64*5),4, true);
    generateSheepPile(k.vec2(64*9+5,64*5-28),5, true);

    generateSheepPile(k.vec2(64*11+30,64*5),4, false);
    generateSheepPile(k.vec2(64*11-15,64*5),4, true);
    generateSheepPile(k.vec2(64*11+30,64*5-28),5, false);
    generateSheepPile(k.vec2(64*11-15,64*5-28),5, true);

    generateSheepPile(k.vec2(64*13+30,64*5),4, false);
    generateSheepPile(k.vec2(64*13-15,64*5),4, true);
    generateSheepPile(k.vec2(64*13+30,64*5-28),5, false);
    generateSheepPile(k.vec2(64*13-15,64*5-28),5, true);
    generateSheepPile(k.vec2(64*13+5,64*4+8),5, true);

    generateSheepPile(k.vec2(64*15+30,64*5),4, false);
    generateSheepPile(k.vec2(64*15-15,64*5),4, true);
    generateSheepPile(k.vec2(64*15+30,64*5-28),5, false);
    generateSheepPile(k.vec2(64*15-15,64*5-28),5, true);
    generateSheepPile(k.vec2(64*15+30,64*4+8),5, false);
    generateSheepPile(k.vec2(64*15-15,64*4+8),5, true);

}